import { useTranslation } from 'react-i18next';
import { AuthContainer } from '../features/DatevAuthStatus/AuthContainer';
import { Body, Heading } from '@e2n/ui/v2';

export function Layout() {
  const { t } = useTranslation();
  return (
    <div className="p-4 md:p-10 h-full bg-neutrals-v2-200">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-3">
          <Heading size={'lg'}>{t('domain.datev.page.title')}</Heading>
          <Body>{t('domain.datev.page.description')}</Body>
        </div>
        <AuthContainer />
      </div>
    </div>
  );
}
